import React from 'react';

// Bouncing Circles Component
const BouncingCircles = ({ size = 'md', className = '' }) => {
  const sizeClasses = {
    sm: 'w-2 h-2',
    md: 'w-3 h-3',
    lg: 'w-4 h-4',
    xl: 'w-5 h-5'
  };

  return (
    <div className={`flex items-center space-x-2 ${className}`}>
      {[0, 1, 2].map((i) => (
        <span 
          key={i} 
          className={`${sizeClasses[size]} rounded-full bg-[#004175] animate-bounce`}
          style={{
            animationDelay: `${i * 0.2}s`,
            animationDuration: '0.8s'
          }}
        />
      ))}
    </div>
  );
};

const Loader = ({ 
  size = 'md', 
  text = 'Loading...', 
  showText = true, 
  className = '',
  overlay = false,
  fullScreen = false 
}) => {
  const containerSizeClasses = {
    sm: 'w-8 h-8',
    md: 'w-12 h-12',
    lg: 'w-16 h-16',
    xl: 'w-20 h-20'
  };

  const textSizeClasses = {
    sm: 'text-sm',
    md: 'text-base',
    lg: 'text-lg',
    xl: 'text-xl'
  };

  const LoaderContent = () => (
    <div className={`flex flex-col items-center justify-center ${className}`}>
      <div className={`${containerSizeClasses[size]} flex items-center justify-center`}>
        <BouncingCircles size={size} />
      </div>
      {showText && (
        <p className={`mt-2 text-gray-600 ${textSizeClasses[size]} font-medium`}>
          {text}
        </p>
      )}
    </div>
  );

  if (overlay) {
    return (
      <div className={`fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 ${fullScreen ? 'h-screen' : ''}`}>
        <div className="bg-white rounded-lg p-6 shadow-xl">
          <LoaderContent />
        </div>
      </div>
    );
  }

  if (fullScreen) {
    return (
      <div className="fixed inset-0 z-50 flex items-center justify-center bg-white">
        <LoaderContent />
      </div>
    );
  }

  return <LoaderContent />;
};

// Inline Loader for small spaces
export const InlineLoader = ({ size = 'sm', className = '' }) => (
  <div className={`inline-flex items-center justify-center ${className}`}>
    <BouncingCircles size={size} />
  </div>
);

// Button Loader for buttons
export const ButtonLoader = ({ size = 'sm', className = '' }) => (
  <div className={`inline-flex items-center justify-center ${className}`}>
    <BouncingCircles size={size} />
  </div>
);

// Table Row Loader
export const TableRowLoader = ({ columns = 5, className = '' }) => (
  <tr className={`border-b border-zinc-100 ${className}`}>
    {Array.from({ length: columns }).map((_, index) => (
      <td key={index} className="px-3 py-2">
        <div className="flex items-center justify-center">
          <BouncingCircles size="sm" />
        </div>
      </td>
    ))}
  </tr>
);

// Top Screen Loader with Background Blur
export const TopScreenLoader = ({ 
  isVisible, 
  text = "", 
  showText = true,
  className = '' 
}) => {
  if (!isVisible) return null;

  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black bg-opacity-30 backdrop-blur-sm">
      <div className={``}>
        <div className="flex flex-col items-center justify-center">
          <BouncingCircles size="lg" />
        </div>
      </div>
    </div>
  );
};

// Global Loading Context Component
export const GlobalLoader = ({ 
  isVisible, 
  text = "Processing...", 
  showText = true,
  className = '' 
}) => {
  if (!isVisible) return null;

  return (
    <div className="fixed top-0 left-0 right-0 z-[9999]backdrop-blur-md border-b border-gray-200 shadow-lg">
      <div className="flex items-center justify-center py-4">
        <div className="flex items-center space-x-3">
          <BouncingCircles size="md" />
          {/* {showText && (
            <span className="text-gray-700 font-medium text-sm">
              {text}
            </span>
          )} */}
        </div>
      </div>
    </div>
  );
};

export default Loader;